import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { merchantAppProductsKeys } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { merchantsListKeys } from "Api/Queries/Merchants/useGetMerchantsQuery";
import {
  type ProductCode,
  deleteMerchantsPublicIDAppProductsCode,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = { merchantPublicID: string; productCode: ProductCode };

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteMerchantAppProductMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, productCode }: Parameters) =>
        deleteMerchantsPublicIDAppProductsCode(merchantPublicID, productCode),
    ),
    onSuccess: (_, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: merchantAppProductsKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: merchantsListKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
